import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_female_tai_chi_walking_v2_fr~1&lang=fr
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-fr',
				locale: ['en'],
			},
		},
	},
]

export default config
